export default __webpack_public_path__ + "static/page4Vp1Bg-169746cb8eb53444d84ca9a7a89c09ed.png";